/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, RemovePayload } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { adminUserMgmtPermissionActions } from "./permissionSlice";
import adminUserMgmtRoleModuleApi from "api/adminUserMgmtRoleModuleApi";
import { RoleModuleForm } from "models/roleModule";

function* getModulesList(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtRoleModuleApi.getModuleList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtPermissionActions.getModulesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(adminUserMgmtPermissionActions.getModulesFailed(errorData));
  }
}

function* getAllModulesList(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtRoleModuleApi.getAllModuleList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(adminUserMgmtPermissionActions.getAllModuleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(adminUserMgmtPermissionActions.getAllModuleListFailed(errorData));
  }
}

function* addRoleModule(action: PayloadAction<RoleModuleForm>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtRoleModuleApi.addModule,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtPermissionActions.addModulesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtPermissionActions.addModulesFailed(errorData));
  }
}

function* updateModule(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtRoleModuleApi.updateModule,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtPermissionActions.updateModuleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtPermissionActions.updateModuleFailed(errorData));
  }
}

function* deleteModule(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      adminUserMgmtRoleModuleApi.deleteModule,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(adminUserMgmtPermissionActions.deleteModuleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(adminUserMgmtPermissionActions.deleteModuleFailed(errorData));
  }
}

export default function* adminUserMgmtPermissionSaga() {
  yield takeLatest(adminUserMgmtPermissionActions.getModules.type, getModulesList);
  yield takeLatest(adminUserMgmtPermissionActions.addModules.type, addRoleModule);
  yield takeLatest(adminUserMgmtPermissionActions.updateModule.type, updateModule);
  yield takeLatest(adminUserMgmtPermissionActions.deleteModule.type, deleteModule);
  yield takeLatest(adminUserMgmtPermissionActions.getAllModuleList.type, getAllModulesList);
}
